import useSWR from 'swr';
import { getCurrentGoal } from '@/repositories/goals';

export function useCurrentGoalData() {
  const { data, isLoading, error, mutate, isValidating } = useSWR(['currentGoal'], () => getCurrentGoal(), {
    dedupingInterval: 10000, // 同じキーでの重複リクエストを防ぐ間隔（10秒）
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    keepPreviousData: true,
    shouldRetryOnError: false
  });

  return {
    data,
    isLoading,
    error,
    mutate,
    isValidating
  };
}
